angular.module('zone').constant('zoneEvents', {
    changeCity: 'changeCity',
    changeAddress: 'changeAddress',
});
